import { render, staticRenderFns } from "./StellarCollectGame.vue?vue&type=template&id=4b8492bb&scoped=true&"
import script from "./StellarCollectGame.vue?vue&type=script&lang=js&"
export * from "./StellarCollectGame.vue?vue&type=script&lang=js&"
import style0 from "./StellarCollectGame.vue?vue&type=style&index=0&id=4b8492bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8492bb",
  null
  
)

export default component.exports